module.exports = __webpack_public_path__ + "img/profile.220c91e6.svg";